import { ProfileStatusType } from '~/enums/accounts/profile-status-type.enum';

export const processStatusMap: Record<string, ProfileStatusType[]> = {
  notStarted: [ProfileStatusType.AwaitingInformation],
  informationCollection: [
    ProfileStatusType.CreationInProgress,
    ProfileStatusType.InformationCollectionInProgress
  ],
  idVerification: [
    ProfileStatusType.IdentityVerificationInProgress,
    ProfileStatusType.IdentityVerificationAbandoned,
    ProfileStatusType.IdentityVerificationError,
    ProfileStatusType.IdentityVerificationInError
  ],
  lemonwayReview: [ProfileStatusType.UnderAnalysis],
  actionRequired: [ProfileStatusType.Rejected],
  declined: [ProfileStatusType.Denied],
  validated: [ProfileStatusType.Accepted]
};
